import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class IssuedByCodeService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    Lookup(pCriteria: LookupCriteria): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IIssuedByCodeService/LookupIssuedByCode", pCriteria);
    }

    getAllIssuedByCodes(): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IIssuedByCodeService/GetAllIssuedByCodes");
    }
}
